import React from 'react'

export default function Section({title, subtitle, subtitle2, subtitleStyle, subtitle2Style, children, className, style, titleClassName, subtitleClassName, id}) {
  
  const SUBTITLE_STYLE = {
    maxWidth: "700px"
  }

  const SUBTITLE_STYLE_PROP = subtitleStyle
  const SUBTITLE2_STYLE_PROP = subtitle2Style
  return (
    <div className={`px-1 md:px-0 mb-8 sm:mb-32 mt-8 w-full ${className}`} style={style}>
      <div className="mb-2 md:mb-4 xl:mb-16">
        {title && <h1 id={id} className={`text-center text-primary font-semibold text-2xl sm:text-4xl mb-5 ${titleClassName}`} >{title}</h1>}
        {subtitle && <p className={`${subtitleClassName} text-center text-lg mx-2 sm:mx-auto text-gray-600`} style={subtitleStyle? SUBTITLE_STYLE_PROP : SUBTITLE_STYLE}>{subtitle}</p>}
        {subtitle2 && <p className={`${subtitleClassName} pt-4 text-center text-lg mx-2 sm:mx-auto text-gray-600`} style={subtitle2Style? SUBTITLE2_STYLE_PROP : SUBTITLE_STYLE}>{subtitle2}</p>}
      </div>
      {children}
    </div>
    
  )
}
